import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab, Typography, Button } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import HistoryIcon from '@mui/icons-material/History';
import AssessmentIcon from '@mui/icons-material/Assessment';
import TabPanel from './TabPanel';
import ActiveTrades from './ActiveTrades';
import TradeHistory from './TradeHistory';
import TradePerformance from './TradePerformance';
import authService from '../services/authService';
import { useNavigate } from 'react-router-dom';

function TradeDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in to show personalized CTA
    const loggedIn = authService.isAuthenticated();
    setIsLoggedIn(loggedIn);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleViewPersonalDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="trade dashboard tabs"
          variant="fullWidth"
        >
          <Tab 
            icon={<UpdateIcon />} 
            iconPosition="start" 
            label="Active Trades" 
            id="trade-tab-0" 
            aria-controls="trade-tabpanel-0" 
          />
          <Tab 
            icon={<HistoryIcon />} 
            iconPosition="start" 
            label="Trade History" 
            id="trade-tab-1" 
            aria-controls="trade-tabpanel-1" 
          />
          <Tab 
            icon={<AssessmentIcon />} 
            iconPosition="start" 
            label="Performance" 
            id="trade-tab-2" 
            aria-controls="trade-tabpanel-2" 
          />
        </Tabs>
      </Box>
      
      {isLoggedIn && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mb: 1 }}>
          <Button 
            variant="outlined" 
            size="small" 
            onClick={handleViewPersonalDashboard}
            startIcon={<AssessmentIcon />}
          >
            View Your Personal Dashboard
          </Button>
        </Box>
      )}
      
      <TabPanel value={tabValue} index={0}>
        <ActiveTrades />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <TradeHistory />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <TradePerformance />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
          Performance metrics calculated from all trades in the system
        </Typography>
      </TabPanel>
    </Box>
  );
}

export default TradeDashboard;